module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-03.be0a4be7.jpg";